export default "__VITE_ASSET__dh_pW8o$__"